// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3kTAT","topBottomGutter":"Layout_topBottomGutter__aU6gr"};